import { config } from "@/config";
import { Provider } from "@/providers/http.provider";
import type { FeatureFlagKey, FeatureFlagsResponse } from "@rebuild/shared";

class FeatureFlagsProvider extends Provider {
  constructor() {
    super({
      baseURL: `${config.baseAPIUrl}/rest/access/`,
    });
  }

  async getFeatureFlags(): Promise<FeatureFlagsResponse> {
    try {
      return await super.get<FeatureFlagsResponse>(`organization/features`);
    } catch (error) {
      console.error("Failed to fetch feature flags:", error);
      return {
        success: false,
        data: {
          featureFlags: {} as Record<FeatureFlagKey, boolean>,
        },
        error: error instanceof Error ? error.message : "Failed to fetch feature flags",
      };
    }
  }
}

export default new FeatureFlagsProvider();
